import { render, staticRenderFns } from "./TherapyTemplatesDialog.vue?vue&type=template&id=1d916c22&scoped=true&"
import script from "./TherapyTemplatesDialog.vue?vue&type=script&lang=js&"
export * from "./TherapyTemplatesDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d916c22",
  null
  
)

export default component.exports